import {RouteObject} from 'react-router';
import {authGuard} from '@common/auth/guards/auth-route';

const lazyTenantRoute = async () => {
  const { TenantIndexPage } = await import('@app/admin/tenants/tenant-routes.lazy');
  return {
    Component: TenantIndexPage,
  };
};

export const appAdminRoutes: RouteObject[] = [
  // TENANTS
  {
    path: 'tenants',
    loader: () => authGuard({permission: 'admin.access'}),
    lazy: () => lazyTenantRoute(),
  },
];
